import { db } from "common/config/Firebase"

const invoiceDetailCollection = db.collection('invoiceDetail')

const findInvoiceDetailByIdUseCase = async (id) => {
    const data = await invoiceDetailCollection.doc(id).get()
    return data.data() || { data: [] }
}

export default findInvoiceDetailByIdUseCase